/**
 * @deprecated
 */
import { DropdownListItem, DropdownProps, Icon } from '@toggle/design-system';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useWatchlistActions } from '~/hooks/use-watchlist-actions/useWatchlistActions';
import { appPaths } from '~/routes/app-paths';
import { useWatchlist } from '~/stores/use-watchlist/useWatchlist';
import { Watchlist } from '~/stores/use-watchlist/watchlist-types';

import * as S from './WatchlistDropdown.styles';

export interface Asset {
  ticker: string;
  price: string;
  daily_change_price: number;
  daily_change_percentage: number;
  pe: string;
  macd: string;
  rsi: string;
}

export interface WatchlistsDropdownProps {
  list?: Watchlist;
  newListName?: string;
  setActiveListId: (props: string) => void;
  onNewListNameChange?: (name: string) => void;
}

export const WatchlistsDropdown = ({
  list,
  setActiveListId,
  newListName = '',
}: WatchlistsDropdownProps) => {
  const { lists } = useWatchlist(state => ({
    lists: state.lists,
  }));
  const { t } = useTranslation('watchlistManager');
  const { navigateToWatchlist } = useWatchlistActions();

  const location = useLocation();
  const activeList: Watchlist = list || {
    id: '',
    name: newListName,
    isFavorite: false,
    entities: [],
    last_update: '',
  };
  const isNewList = !activeList.id;

  const onCreateListClick = () => {
    if (location.pathname === appPaths.watchlistManager) {
      setActiveListId?.('');
    } else {
      navigateToWatchlist(undefined, true);
    }
  };

  return (
    <S.Wrapper>
      <S.StyledDropdown<FC<DropdownProps<Watchlist>>>
        selectItem={element => {
          setActiveListId?.(element.id);
        }}
        afterInListNode={
          <>
            <S.DropdownDivider />
            <DropdownListItem
              label={t('watchlistManager:createNewWatchlist')}
              leadingIcon={<Icon iconName="Add" />}
              isActive={false}
              isFocused={false}
              onClick={onCreateListClick}
              data-testid="create-list-btn"
              isDisabled={!lists.length || isNewList}
            />
          </>
        }
        dropdownItems={lists}
        activeItemIdx={list && lists.findIndex(e => e.id === list.id)}
        shouldShowItems={false}
        placement="bottom-start"
        inPortal
        renderDropdownItem={(item, isActive, isFocused) => (
          <DropdownListItem
            label={item.name}
            isActive={isActive}
            isFocused={isFocused}
          />
        )}
      >
        <S.DropdownTrigger
          label={activeList.name}
          iconName="ChevronLightDown"
          variant="empty"
          size="small"
          data-testid="dropdown-trigger"
          iconPosition="right"
        />
      </S.StyledDropdown>
    </S.Wrapper>
  );
};
